export const BASE_URL = 'https://www.portolanodelpo.it/poServer' //live url

export const Signal = [
    {
        icon: '',
        name: 'Segnale di Chiamata',
        slug: 'call',
        styleUrl: '#icon-ci-2',
        extendedData_Tipo: 'Chiamata',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
    {
        icon: '',
        name: 'Segnale di Rimando',
        slug: 'return',
        styleUrl: '#icon-ci-1',
        extendedData_Tipo: 'Rimando',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
    {
        icon: './assets/images/signs/tocca-scappa-icon-ci-4.svg',
        name: 'Segnale Tocca-Scappa',
        slug: 'touch_run',
        styleUrl: '#icon-ci-4',
        extendedData_Tipo: 'Tocca-scappa',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
    {
        icon: './assets/images/signs/prosecuzione-icon-ci-3.svg',
        name: 'Segnale di prosecuzione',
        slug: 'continue',
        styleUrl: '#icon-ci-3',
        extendedData_Tipo: 'Prosecuzione',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
    {
        icon: './assets/images/signs/campata-navigabile-icon-ci-5.svg',
        name: 'Campata navigabile',
        slug: 'prosecuzione',
        styleUrl: '#icon-ci-5',
        extendedData_Tipo: 'Campata navigabile',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
    {
        icon: './assets/images/signs/direzione-icon-ci-11.svg',
        name: 'Direzione destra',
        slug: 'direzione',
        styleUrl: '#icon-ci-11',
        extendedData_Tipo: 'Direzione destra',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
    {
        icon: './assets/images/signs/direzione-icon-ci-11-sx.svg',
        name: 'Direzione sinistra',
        slug: 'direzione_sx',
        styleUrl: '#icon-ci-11-sx',
        extendedData_Tipo: 'Direzione sinistra',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
    {
        icon: './assets/images/signs/divieto-transito-icon-ci-14.svg',
        name: 'Divieto di transito',
        slug: 'divieto_transito',
        styleUrl: '#icon-ci-12',
        extendedData_Tipo: 'Divieto di transito',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
    {
        icon: './assets/images/signs/navigare-prudenza-icon-ci-6.svg',
        name: 'Navigare con prudenza',
        slug: 'navigare_prudenza',
        styleUrl: '#icon-ci-6',
        extendedData_Tipo: 'Navigare con prudenza',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
    {
        icon: './assets/images/signs/obbligo-fermata-icon-ci-13.svg',
        name: 'Obbligo di fermata',
        slug: 'obbligo_fermata',
        styleUrl: '#icon-ci-13',
        extendedData_Tipo: 'Obbligo di fermata',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
    {
        icon: './assets/images/signs/ostacoli-icon-ci-9-3.svg',
        name: 'Ostacoli',
        slug: 'ostacoli',
        styleUrl: '#icon-ci-9-2',
        extendedData_Tipo: 'Ostacoli',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
    {
        icon: './assets/images/signs/boa-bianca-icon-ci-8.svg',
        name: 'Boa Bianca',
        slug: 'buoy_white',
        styleUrl: '#icon-ci-8',
        extendedData_Tipo: 'Boa Bianca',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
    {
        icon: './assets/images/signs/boa-rossa-icon-ci-10.svg',
        name: 'Boa Rossa',
        slug: 'buoy_red',
        styleUrl: '#icon-ci-10',
        extendedData_Tipo: 'Boa Rossa',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
    {
        icon: './assets/images/signs/boa-bianca-icon-ci-8.svg',
        name: 'Boa Bianca Virtuale',
        slug: 'buoy_white_virtual',
        styleUrl: '#icon-ci-14',
        extendedData_Tipo: 'Boa Bianca Virtuale',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
    {
        icon: './assets/images/signs/boa-rossa-icon-ci-10.svg',
        name: 'Boa Rossa Virtuale',
        slug: 'buoy_red_virtual',
        styleUrl: '#icon-ci-15',
        extendedData_Tipo: 'Boa Rossa Virtuale',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
]

export const Buoy = [
    {
        icon: './assets/images/sign-5.png',
        name: 'Boa Bianca',
        slug: 'buoy_white',
        styleUrl: '#icon-ci-8',
        extendedData_Tipo: 'Boa Bianca',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
    {
        icon: './assets/images/sign-6.png',
        name: 'Boa Rossa',
        slug: 'buoy_red',
        styleUrl: '#icon-ci-10',
        extendedData_Tipo: 'Boa Rossa',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
    {
        icon: './assets/images/signs/boa-bianca-icon-ci-8.svg',
        name: 'Boa Bianca Virtuale',
        slug: 'buoy_white_virtual',
        styleUrl: '#icon-ci-14',
        extendedData_Tipo: 'Boa Bianca Virtuale',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
    {
        icon: './assets/images/signs/boa-rossa-icon-ci-10.svg',
        name: 'Boa Rossa Virtuale',
        slug: 'buoy_red_virtual',
        styleUrl: '#icon-ci-15',
        extendedData_Tipo: 'Boa Rossa Virtuale',
        extendedData_Nome_Local: '',
        extendedData_Tratto: ''
    },
]

export const riverSections = [
    {
      id: 1,
      name: "Piacenza",
      river_area_id: 1,
      lat_start: 45.06597100,
      lng_start: 9.69129500,
      lat_end: 45.12933114,
      lng_end: 9.99366927
    },
    {
      id: 2,
      name: "Polesine Parmense",
      river_area_id: 1,
      lat_start: 45.12933114,
      lng_start: 9.99366927,
      lat_end: 44.98996629,
      lng_end: 10.29800813
    },
    {
      id: 3,
      name: "Boretto",
      river_area_id: 2,
      lat_start: 44.98996629,
      lng_start: 10.29800813,
      lat_end: 44.92545473,
      lng_end: 10.62650011
    },
    {
      id: 4,
      name: "Riva di Suzzara",
      river_area_id: 2,
      lat_start: 44.92545473,
      lng_start: 10.62650011,
      lat_end: 45.05242608,
      lng_end: 10.88684710
    },
    {
      id: 5,
      name: "Revere",
      river_area_id: 3,
      lat_start: 45.05242608,
      lng_start: 10.88684710,
      lat_end: 45.05938419,
      lng_end: 11.20232983
    },
    {
      id: 6,
      name: "Felonica",
      river_area_id: 3,
      lat_start: 45.05938419,
      lng_start: 11.20232983,
      lat_end: 44.93177154,
      lng_end: 11.44636336
    },
    {
      id: 7,
      name: "Santa Maria Maddalena",
      river_area_id: 4,
      lat_start: 44.93177154,
      lng_start: 11.44636336,
      lat_end: 44.94922229,
      lng_end: 11.74152758
    },
    {
      id: 8,
      name: "Papozze",
      river_area_id: 4,
      lat_start: 44.94922229,
      lng_start: 11.74152758,
      lat_end: 45.02135995,
      lng_end: 12.10522144
    },
    {
      id: 9,
      name: "Volta Grimana",
      river_area_id: 4,
      lat_start: 45.02135995,
      lng_start: 12.10522144,
      lat_end: 44.96396091,
      lng_end: 12.56428597
    },
    {
      id: 10,
      name: "Foce Ticino",
      river_area_id: 1,
      lat_start: 45.14014454,
      lng_start: 9.22646893,
      lat_end: 45.06597100,
      lng_end: 9.69129500
    }
  ];
  
  export const riverZones = [
    {
      id: 1,
      name: "Isola Serafini",
      lat_start: 45.06597100,
      lng_start: 9.69129500,
      lat_end: 44.98996629,
      lng_end: 10.29800813
    },
    {
      id: 2,
      name: "Boretto",
      lat_start: 44.98996629,
      lng_start: 10.29800813,
      lat_end: 45.05242608,
      lng_end: 10.88684710
    },
    {
      id: 3,
      name: "Revere",
      lat_start: 45.05242608,
      lng_start: 10.88684710,
      lat_end: 44.93177154,
      lng_end: 11.44636336
    },
    {
      id: 4,
      name: "Veneto",
      lat_start: 44.93177154,
      lng_start: 11.44636336,
      lat_end: 44.96396091,
      lng_end: 12.56428597
    }
  ];
  
  